'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import ContentRoutes from 'ContentUtils/Routes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import { ContentTypes, ContentTypeToContentSlug } from '../constants/base';
export default class ErrorPage extends PureComponent {
  langKey(suffix) {
    const {
      contentType
    } = this.props;
    return `app.errorPages.${suffix}.${contentType}`;
  } // Get the shared error message type for UIErrorMessage if matches


  getGenericErrorMessageType() {
    const {
      statusCode,
      errorType
    } = this.props;

    switch (statusCode) {
      case 404:
        return errorType === 'USER_NOT_AUTHORIZED' ? null : 'notFound';

      case 500:
        return 'badRequest';

      default:
        return null;
    }
  }

  renderDashboardLink() {
    const {
      contentType
    } = this.props;

    if (contentType === ContentTypes.EXTERNAL_PAGE) {
      return null;
    }

    return /*#__PURE__*/_jsx(UILink, {
      href: ContentRoutes.dashboard(ContentTypeToContentSlug[contentType]),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `app.backToDashboardLink.${contentType}`
      })
    });
  }

  renderErrorBody(prefix, {
    showDescription,
    showNextStep
  }) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [showDescription && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.langKey(`${prefix}.description`)
        })
      }), showNextStep && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: this.langKey(`${prefix}.nextStep`)
        })
      }), this.renderDashboardLink()]
    });
  }

  render() {
    const errorMessageType = this.getGenericErrorMessageType();

    if (errorMessageType) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        className: errorMessageType,
        type: errorMessageType,
        children: this.renderErrorBody(errorMessageType, {
          showDescription: true
        })
      });
    }

    const {
      errorType,
      statusCode
    } = this.props;

    if (errorType === 'USER_NOT_AUTHORIZED') {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        className: "notPermissioned",
        illustration: "keys",
        title: I18n.text(this.langKey('notPermissioned.title')),
        children: this.renderErrorBody('notPermissioned', {
          showNextStep: true
        })
      });
    }

    if (statusCode === 403) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        className: "notAuthorized",
        type: "403",
        children: this.renderErrorBody('notAuthorized', {
          showDescription: true
        })
      });
    }

    return /*#__PURE__*/_jsx(UIErrorMessage, {
      className: "unknownError",
      type: "notFound",
      children: this.renderErrorBody('notFound', {
        showDescription: true
      })
    });
  }

}
ErrorPage.propTypes = {
  contentType: PropTypes.string,
  errorType: PropTypes.string,
  statusCode: PropTypes.number
};